module.exports = __webpack_public_path__ + "img/border-width.21074c33.svg";